import {AnalyticsVisualizationOutlierSetting as OutlierSetting} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';

type OutlierConfig = NonNullable<
  ExtractByTypename<
    AnalyticsVisualization['parameters'],
    'AnalyticsVisualizationScatterPlotParametersNode'
  >['outlierConfig']
>;

export const AGGREGATED_OUTLIER_LABEL = 'Aggregation includes outlier(s)';
export const DETECTED_OUTLIER_LABEL = 'Outlier';
export const EXCLUDED_OUTLIER_LABEL = 'Excluded outlier';

export const NULL_OUTLIER_SETTING = "Don't detect";

export const OUTLIER_SETTING_TO_READABLE: {[key in OutlierSetting]: string} = {
  [OutlierSetting.DETECT]: 'Detect',
  [OutlierSetting.EXCLUDE]: 'Detect and exclude',
};

export const OUTLIER_TOOLTIP_INFO =
  'Excluded outliers are omitted from regressions, aggregations, and error bars.';

export function buildDefaultOutlierConfig(outlierSetting: OutlierSetting): OutlierConfig {
  return {
    __typename: 'OutlierConfigNode',
    outlierSetting,
    qValue: 0.01,
  };
}
